import { FeedbackAction } from '#shared/types/Feedback'

export function shouldBeInformal(action: FeedbackAction): boolean {
    return action === FeedbackAction.JOB_APPLICATION || action === FeedbackAction.VOLUNTEER_REQUEST_REJECT
}
